/**
 * Created by devmaster on 7/15/2017 AD.
 */

import React, { Component } from 'react'

export  default class BankListRow extends Component{

  render(){

    var bankList ;

    if(this.props.bank_list.length === 0){
       bankList = <tr><td colSpan={3} className="text-center"><span className="text-danger">ไม่พบข้อมูล</span></td></tr>
    }else {

       bankList = this.props.bank_list.map((bank, index) => {
        return (
          <tr key={index}>
            <td>{ index+1 }</td>
            <td>{ bank.bank_name }</td>
            <td className="text-right">
              <button className="btn btn-sm btn-danger btn-md-width"
                      onClick={this.props.bankCallbacks.delete.bind(null,bank)}
              >
                <i className="fa fa-remove"></i> ลบ
              </button>
              <button className="btn btn-sm btn-warning btn-md-width"
                      onClick={this.props.bankCallbacks.edit.bind(null,bank)}
              >
                <i className="fa fa-edit"></i> แก้ไข
              </button>
            </td>
          </tr>
        )
      });
    }

    return (

          <table className="table table-striped">
            <thead>
            <tr>
              <th className="text-left">#</th>
              <th className="text-left">ชื่อธนาคาร</th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            { bankList }
          </tbody>
          </table>

    );
  }
}